import { LOCAL_STORE_NAMES } from '@/constants/settings.js'
import { LOCALIZATION } from '@/constants/store.js'

const initState = () => {
  const locales = [
    {
      locale: 'ru',
      lang: 'Русский'
    },
    {
      locale: 'en',
      lang: 'English'
    }
  ]

  const locale = localStorage.getItem(LOCAL_STORE_NAMES.LOCALE)

  return {
    locale,
    locales
  }
}

const state = initState()

const actions = {
  async [LOCALIZATION.ACTIONS.SET_LOCALE] ({ commit }, locale) {
    localStorage.setItem(LOCAL_STORE_NAMES.LOCALE, locale)
    // перезагрузка приложения для инициализации всех плагинов,
    // которые зависят от локализации + перезапрос данных в соответствии с новой локализацией
    window.location.reload(true)
  },
  async [LOCALIZATION.ACTIONS.SET_LOCALE_WITHOUT_RELOAD] ({ commit }, locale) {
    localStorage.setItem(LOCAL_STORE_NAMES.LOCALE, locale)
  },
  async [LOCALIZATION.ACTIONS.REFRESH_LOCALE] ({ commit }) {
    commit(LOCALIZATION.MUTATIONS.REFRESH_LOCALE)
  }
}

const mutations = {
  [LOCALIZATION.ACTIONS.REFRESH_LOCALE] (state) {
    state.locale = localStorage.getItem(LOCAL_STORE_NAMES.LOCALE)
  }
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}
